import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScenarioItem } from '../scenario-item';

const COMPONENT_SELECTOR = 'wlm-scenario-item';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './scenario-item.component.html',
  styleUrl: './scenario-item.component.scss',
  standalone: false,
})
export class ScenarioItemComponent implements OnInit {
  @Input() scenario: ScenarioItem;
  @Input() innerItemClass: string;
  @Input() map;

  @Output() scenarioVisibilityChange = new EventEmitter<ScenarioItem>();

  layerIsVisible = true;

  constructor() {}
  ngOnInit(): void {}

  hideLayer(e) {
    e.stopPropagation();
    this.layerIsVisible = false;
    this.scenarioVisibilityChange.emit(
      new ScenarioItem(
        this.scenario.scenarioId,
        this.scenario.scenarioName,
        this.layerIsVisible,
        this.scenario.instanceId,
        this.scenario.snapshotId
      )
    );
  }

  showLayer(e) {
    e.stopPropagation();
    this.layerIsVisible = true;
    this.scenarioVisibilityChange.emit(
      new ScenarioItem(
        this.scenario.scenarioId,
        this.scenario.scenarioName,
        this.layerIsVisible,
        this.scenario.instanceId,
        this.scenario.snapshotId
      )
    );
  }
}
